import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  termsOfUse: {
    id: 'portal.views.termsOfUse.label.title',
    defaultMessage: 'Terms of Use',
    description: 'Terms of Use page title',
  },
  termsBgAlt: {
    id: 'portal.views.termsOfUse.bg.alt',
    defaultMessage: 'Terms of use background',
    description: 'Terms of use background image alt',
  },
  section1Title: {
    id: 'portal.views.termsOfUse.section.1.title',
    defaultMessage: '1. Acceptance of Terms',
    description: 'Section 1 title',
  },
  section1Text: {
    id: 'portal.views.termsOfUse.section.1.text',
    defaultMessage: 'By accessing and using this website, you agree to comply with and be bound '
      + 'by these Terms of Use. If you do not agree to these terms, please refrain from using the site.',
    description: 'Section 1 text',
  },
  section2Title: {
    id: 'portal.views.termsOfUse.section.2.title',
    defaultMessage: '2. Use of Website',
    description: 'Section 2 title',
  },
  section2Text: {
    id: 'portal.views.termsOfUse.section.2.text',
    defaultMessage: 'You agree to use this website only for lawful purposes and in a manner that '
      + 'does not infringe the rights of or restrict or inhibit the use and enjoyment of this website by any third party.',
    description: 'Section 2 text',
  },
  section3Title: {
    id: 'portal.views.termsOfUse.section.3.title',
    defaultMessage: '3. Intellectual Property',
    description: 'Section 3 title',
  },
  section3Text: {
    id: 'portal.views.termsOfUse.section.3.text',
    defaultMessage: 'All content on this website, including text, images, graphics, logos, '
      + 'and other materials, is the property of Legatum Limited or the University of Oxford '
      + 'or their licensors and is protected by copyright, trademark, and other intellectual '
      + 'property laws. You may not reproduce, distribute, modify, or otherwise use any '
      + 'content without prior written consent.',
    description: 'Section 3 text',
  },
  section4Title: {
    id: 'portal.views.termsOfUse.section.4.title',
    defaultMessage: '4. User-Generated Content',
    description: 'Section 4 title',
  },
  section4Text: {
    id: 'portal.views.termsOfUse.section.4.text',
    defaultMessage: 'If you submit content to this website, you grant Legatum Limited '
      + 'a non-exclusive, worldwide, royalty-free license to use, reproduce, modify, '
      + 'and display such content. You are solely responsible for ensuring that your '
      + 'submissions do not violate any laws or infringe on third-party rights.',
    description: 'Section 4 text',
  },
  section5Title: {
    id: 'portal.views.termsOfUse.section.5.title',
    defaultMessage: '5. Disclaimers and Limitation of Liability',
    description: 'Section 5 title',
  },
  section5Text: {
    id: 'portal.views.termsOfUse.section.5.text',
    defaultMessage: 'This website is provided on an “as is” and “as available” basis. '
      + 'Legatum Limited makes no representation or warranty of any kind, express or '
      + 'implied: (i) as to the operation or availability of the website or any services '
      + 'offered thereon, or the information, content, and materials or products included '
      + 'thereon; (ii) that the website or any services offered thereon will be uninterrupted '
      + 'or error-free; (iii) as to the accuracy, reliability, or currency of any information '
      + 'or content provided through the website; or (iv) that the website, its servers, '
      + 'the content, or e-mails sent from or on behalf of Legatum Limited are free of viruses, '
      + 'scripts, trojan horses, worms, malware, timebombs or other harmful '
      + 'components.\nTo the maximum extent permitted by applicable law, in no event shall '
      + 'Legatum Limited or its affiliates be liable for any special, incidental, indirect, '
      + 'or consequential damages whatsoever, including, but not limited to, damages for loss '
      + 'of profits, loss of data or other information, for business interruption, for personal '
      + 'injury, loss of privacy arising out of or in any way related to the use of or inability '
      + 'to use the website, third-party software and/or third-party hardware used with the website, '
      + 'or otherwise in connection with any provision of these Terms of Use, even if Legatum Limited '
      + 'or any supplier has been advised of the possibility of such damages and even if the remedy '
      + 'fails of its essential purpose.',
    description: 'Section 5 text',
  },
  section6Title: {
    id: 'portal.views.termsOfUse.section.6.title',
    defaultMessage: '6. Third-Party Links',
    description: 'Section 6 title',
  },
  section6Text: {
    id: 'portal.views.termsOfUse.section.6.text',
    defaultMessage: 'This website may contain links to third-party websites. Legatum Limited is not '
      + 'responsible for the content or practices of those sites and provides these links solely for your convenience.',
    description: 'Section 6 text',
  },
  section7Title: {
    id: 'portal.views.termsOfUse.section.7.title',
    defaultMessage: '7. Modifications to Terms',
    description: 'Section 7 title',
  },
  section7Text: {
    id: 'portal.views.termsOfUse.section.7.text',
    defaultMessage: 'Legatum Limited reserves the right to update or modify these Terms of Use at any '
      + 'time without prior notice. Continued use of the website following changes constitutes '
      + 'acceptance of the updated terms.',
    description: 'Section 7 text',
  },
  section8Title: {
    id: 'portal.views.termsOfUse.section.8.title',
    defaultMessage: '8. Governing Law',
    description: 'Section 8 title',
  },
  section8Text: {
    id: 'portal.views.termsOfUse.section.8.text',
    defaultMessage: 'These Terms of Use are governed by the laws of England and Wales, and any disputes '
      + 'will be resolved in the courts of England. If you have any concern or dispute related to the '
      + 'use of this website, you agree to first attempt to resolve the dispute informally '
      + 'by contacting Legatum at <link>support@leadingwithcharacter.com</link>.',
    description: 'Section 8 text',
  },
  section9Title: {
    id: 'portal.views.termsOfUse.section.9.title',
    defaultMessage: '9. Contact Us',
    description: 'Section 9 title',
  },
  section9Text: {
    id: 'portal.views.termsOfUse.section.9.text',
    defaultMessage: 'For any questions or concerns about these Terms of Use, '
      + 'please contact us at <link>support@leadingwithcharacter.com</link>.',
    description: 'Section 9 text',
  },
});

export default messages;
